import React, { useEffect } from "react";
import { Modal, Input, Select, Form, Checkbox, Radio } from "antd";
import { observer } from "mobx-react";
import { communitiesStore } from "../../store/community/CommunitiesStore";
import { defaultFormLayout } from "../../common/Utils";
import { ZipCodesInput } from "./ZipCodesInput";

export const EditCommunityDlg = observer(({ onOk }) => {
  const [form] = Form.useForm();
  const store = communitiesStore.edit;

  useEffect(() => {
    store.childcareFare();
  }, []);
  useEffect(() => {
    form.setFieldsValue(store.model);
  }, [store.visible, store.model]);

  const save = () => {
    form.validateFields().then((values) => {
      store.save(values).then(() => {
        onOk && onOk();
      });
    });
  };

  const onState = (state) => {
    store.model.state = state;
    form.setFieldsValue({ city: undefined });
  };
  return (
    <Modal
      title="Community"
      visible={store.visible}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={store.saving}
      onCancel={() => store.close()}
      width={680}
    >
      <Form form={form} {...defaultFormLayout}>
        <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please input name" }]}>
          <Input placeholder="Enter name" />
        </Form.Item>
        <Form.Item label="Division" name="divisionId" rules={[{ required: true, message: "Please select division" }]}>
          <Select>
            {store.divisions.map((x) => (
              <Select.Option value={x.id} key={x.id}>
                {x.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="State" name="state" rules={[{ required: true, message: "Please select state" }]}>
          <Select showSearch placeholder="Enter state" optionFilterProp="title" onChange={onState}>
            {store.states.map((x) => (
              <Select.Option title={`${x.value} (${x.key})`} value={x.key} key={x.key}>
                {x.value} ({x.key})
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Price Pack"
          name="pricePack"
          rules={[{ required: true, message: "Please select price pack" }]}
        >
          <Select showSearch placeholder="Enter price pack" optionFilterProp="title">
            {store.childcareFares.map((x) => (
              <Select.Option title={`${x}`} value={x} key={x}>
                {x}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Carpool Free" name="carpoolFree" valuePropName="checked">
          <Checkbox></Checkbox>
        </Form.Item>
        <Form.Item label="Notes" name="description">
          <Input placeholder="Enter notes" />
        </Form.Item>
        <Form.Item label="Status" name="status">
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="Active">Active</Radio.Button>
            <Radio.Button value="Visible">Inactive (Users Waiting)</Radio.Button>
            <Radio.Button value="Inactive">Inactive (No User)</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Zip Codes"
          name="zipCodes"
          rules={[
            ({ getFieldValue }) => ({
              validator(rule, value: string[]) {
                if (value.every((v) => v.trim() === "" || /\d{5}/.test(v.trim()))) {
                  return Promise.resolve();
                }
                return Promise.reject("Include invalid zip code.");
              },
            }),
          ]}
        >
          <ZipCodesInput />
        </Form.Item>
      </Form>
    </Modal>
  );
});
